/* eslint-disable no-unused-vars */
import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
import DashboardLayout from '../layouts/dashboard';
import { PATH_AFTER_LOGIN } from '../config';
import LoadingScreen from '../components/LoadingScreen';


const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    { path: '/', element: <Login /> },
    // { path: '/login/admin', element: <Login/> },
    { path: '/codemail', element: <CodeMail /> },
    { path: '/login/company', element: <CompanyLogin /> },
    { path: '/login/clinic', element: <ClinicLogin /> },
    { path: '/forget', element: <Register /> },
    { path: '/reset-passsword', element: <ResetPassword usertype={'company'} /> },
    { path: '/clinic-reset-passsword', element: <ResetPassword usertype={'clinic'} /> },
    {
      path: 'dashboard',
      element: (
        <DashboardLayout />
      ),
      children: [

        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'home', element: <GeneralAnalytics /> },

        { path: 'dorm', element: <Dorm /> },
        { path: 'editdorm/:id', element: <EditDorm /> },
        { path: 'adddorm', element: <AddDorm /> },
        { path: 'element', element: <Element /> },
        { path: 'editelement/:id', element: <EditElement /> },
        { path: 'viewelement/:id', element: <ViewElement /> },
        { path: 'companyProfile', element: <CompanyProfile /> },
        { path: 'addelement', element: <AddElement /> },
        { path: 'rarity', element: <Rarity /> },
        { path: 'editrarity/:id', element: <EditRarity /> },
        { path: 'editcategory/:id', element: <EditCategory /> },
        { path: 'addrarity', element: <AddRarity /> },
        { path: 'spell', element: <Spell /> },
        { path: 'editspell/:id', element: <EditSpell /> },
        { path: 'editadmin', element: <EditAdmin /> },
        //  category
        { path: 'category', element: <Category /> },
        { path: 'addcategory', element: <AddCategory /> },
        { path: 'editcategory', element: <EditCategory /> },
        //  Bundles
        { path: 'bundles', element: <Bundles /> },
        { path: 'addbundles', element: <AddBundles /> },
        { path: 'editbundle/:id', element: <EditBundles /> },

        { path: 'items/:id', element: <Items /> },
        { path: 'additems/:id', element: <AddItems /> },
        { path: 'edititems/:id', element: <EditItems /> },

        { path: 'cards', element: <Cards /> },
        { path: 'addcards', element: <AddCards /> },
        { path: 'editcards/:id', element: <EditCards /> },


        { path: 'carditems/:id', element: <CardsItems /> },
        { path: 'cardadditems/:id', element: <AddCardsItems /> },
        { path: 'cardedititems/:id', element: <EditCardsItems /> },

        { path: 'lead', element: <Leads /> },
        { path: 'orders', element: <Orders /> },

        { path: 'area', element: <Area /> },
        { path: 'addarea', element: <AddArea /> },
        { path: 'editarea/:id', element: <EditArea /> },

        {
          path: 'e-commerce',
          children: [
            { element: <Navigate to="/dashboard/e-commerce/shop" replace />, index: true },
          ],
        },
      ],
    },
  ]);
}

// AUTHENTICATION
const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const CompanyLogin = Loadable(lazy(() => import('../pages/auth/CompanyLogin')));
const ClinicLogin = Loadable(lazy(() => import('../pages/auth/ClinicLogin')));
const Register = Loadable(lazy(() => import('../pages/auth/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/auth/ResetPassword')));
const CodeMail = Loadable(lazy(() => import('../pages/auth/CodeMail')));


const Home = Loadable(lazy(() => import('../pages/dashboard/Home/Home')));
const Dorm = Loadable(lazy(() => import('../pages/dashboard/Subscription/Dorm')));
const EditDorm = Loadable(lazy(() => import('../pages/dashboard/Subscription/EditDorm')));
const AddDorm = Loadable(lazy(() => import('../pages/dashboard/Subscription/AddDorm')));

const Leads = Loadable(lazy(() => import('../pages/dashboard/Subscription/Leads')));
const Orders = Loadable(lazy(() => import('../pages/dashboard/Orders/Order')));

const Element = Loadable(lazy(() => import('../pages/dashboard/Company/Element')));
const EditElement = Loadable(lazy(() => import('../pages/dashboard/Company/EditElement')));
const CompanyProfile = Loadable(lazy(() => import('../pages/dashboard/Company/CompanyProfile')));
const AddElement = Loadable(lazy(() => import('../pages/dashboard/Company/AddElement')));
const ViewElement = Loadable(lazy(() => import('../pages/dashboard/Company/ViewElement')));



const Rarity = Loadable(lazy(() => import('../pages/dashboard/TermCondition.js/Rarity')));
const EditRarity = Loadable(lazy(() => import('../pages/dashboard/TermCondition.js/EditRarity')));
const AddRarity = Loadable(lazy(() => import('../pages/dashboard/TermCondition.js/AddRarity')));
const EditAdmin = Loadable(lazy(() => import('../pages/dashboard/EditAdmin/EditAdmin')));

const Spell = Loadable(lazy(() => import('../pages/dashboard/Provider/Spell')));
const EditSpell = Loadable(lazy(() => import('../pages/dashboard/Provider/EditSpell')));
const GeneralAnalytics = Loadable(lazy(() => import('../pages/dashboard/GeneralAnalytics')));

const Category = Loadable(lazy(() => import('../pages/dashboard/Category/Category')));
const EditCategory = Loadable(lazy(() => import('../pages/dashboard/Category/EditCategory')));
const AddCategory = Loadable(lazy(() => import('../pages/dashboard/Category/AddCategory')));

const Bundles = Loadable(lazy(() => import('../pages/dashboard/Bunldles/Bundles')));
const EditBundles = Loadable(lazy(() => import('../pages/dashboard/Bunldles/EditBundles')));
const AddBundles = Loadable(lazy(() => import('../pages/dashboard/Bunldles/AddBundles')));

const Items = Loadable(lazy(() => import('../pages/dashboard/Bunldles/Items/Items')));
const EditItems = Loadable(lazy(() => import('../pages/dashboard/Bunldles/Items/EditItems')));
const AddItems = Loadable(lazy(() => import('../pages/dashboard/Bunldles/Items/AddItems')));

const Cards = Loadable(lazy(() => import('../pages/dashboard/Card/Card')));
const EditCards = Loadable(lazy(() => import('../pages/dashboard/Card/EditCard')));
const AddCards = Loadable(lazy(() => import('../pages/dashboard/Card/AddCard')));

const CardsItems = Loadable(lazy(() => import('../pages/dashboard/Card/Items/Items')));
const EditCardsItems = Loadable(lazy(() => import('../pages/dashboard/Card/Items/EditItems')));
const AddCardsItems = Loadable(lazy(() => import('../pages/dashboard/Card/Items/AddItems')));

const Area = Loadable(lazy(() => import('../pages/dashboard/Area/Area')));
const EditArea = Loadable(lazy(() => import('../pages/dashboard/Area/EditArea')));
const AddArea = Loadable(lazy(() => import('../pages/dashboard/Area/AddArea')));


